module.exports = __webpack_public_path__ + "img/zhuangxiu_bg.b2693e7f.png";